import './FormStyles.css';
import useInputString from '../../hooks/useInputString';
import { useState } from 'react';
import ClassicButton from '../UI/ClassicButton/ClassicButton';
import { EyeFill, EyeSlashFill, XLg } from 'react-bootstrap-icons';
import { IUserLogInRequestModel } from '../../interfaces/requests/IUserLogInRequestModel';
import { login } from '../../http/userAPI';
import FromAlert from './FromAlert';
import useUser from '../../hooks/useUser';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

interface LoginProps {
    closeModal: () => void;
}

const Login: React.FC<LoginProps> = observer(({ closeModal }) => {
    const [isLoading, setLoading] = useState<boolean>(false)
    const email = useInputString('');
    const password = useInputString('');
    const [passwordShown, setPasswordShown] = useState<boolean>(false);
    const [errorFields, setErrorFields] = useState<string[]>([]);
    const [isAlertVisible, setAlertVisible] = useState<boolean>();
    const [alertMessage, setAlertMessage] = useState<string>();
    const user = useUser();
    const navigate = useNavigate();
    
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };
    
    const closeAlert = () => {
        setAlertVisible(false);
    };
    
    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        
        const missingFields = [];
        if (!email.value) missingFields.push('email');
        if (!password.value) missingFields.push('password');
        
        if (missingFields.length > 0) {
            setAlertMessage('Заполните все обязательные поля для входа.');
            setAlertVisible(true);
            setErrorFields(missingFields);
            setLoading(false);
            return;
        }
        
        const userData: IUserLogInRequestModel = {
            email: email.value,
            password: password.value,
        };
        
        login(userData)
            .then((response) => {
                if (Array.isArray(response)) {
                    setAlertMessage(response.join(', '));
                    setAlertVisible(true);
                } else {
                    user.login(response);
                    email.reset();
                    password.reset();
                    closeModal();
                    setAlertMessage('');
                    setAlertVisible(false);
                    
                    if (user.isAdmin) {
                        navigate('/admin-panel')
                    }
                }
            })
            .catch((responce) => {
                setAlertMessage(responce);
            })
            .finally(() => {
                setLoading(false);
                setErrorFields([]);
            });
    };
    
    return (
        <div className='form_container'>
            <h2>Вход</h2>
            <form className="form">
                {isAlertVisible && (
                    <FromAlert onClose={closeAlert}>
                        {alertMessage}
                    </FromAlert>
                )}
                
                <div className={`form_inputContainer`}>
                    <p>Почта</p>
                    <input
                        className={`email ${errorFields.includes('email') ? 'error' : ''}`}
                        type="email"
                        value={email.value}
                        onChange={email.onChange}
                        autoComplete="email"
                    />
                </div>
                
                <div className={`form_inputContainer`}>
                    <p>Пароль</p>
                    <div className='input_passwordWrapper'>
                        <input
                            className={`password ${passwordShown ? '' : 'active'} ${errorFields.includes('password') ? 'error' : ''}`}
                            type={passwordShown ? "text" : "password"}
                            value={password.value}
                            onChange={password.onChange}
                            autoComplete="new-password"
                        />
                        <div className="toggle_password" onClick={togglePasswordVisibility}>
                            {passwordShown ? <EyeSlashFill /> : <EyeFill />}
                        </div>
                    </div>
                </div>
                
                <ClassicButton isLoading={isLoading} onClick={handleLogin} width='60%' height='40px' innerLoaderSize='20px'>
                    Войти
                </ClassicButton>
            </form>
            
            <XLg className='form_closeButton' onClick={closeModal} />
        </div>
    );
})

export default Login;